import { render, staticRenderFns } from "./OrderType.vue?vue&type=template&id=32de6dc6&"
import script from "./OrderType.vue?vue&type=script&lang=ts&"
export * from "./OrderType.vue?vue&type=script&lang=ts&"
import style0 from "./OrderType.vue?vue&type=style&index=0&id=32de6dc6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports